<div class="p-4 flex flex-col">
  <div class="flex justify-between py-8 border-b">
    <div>
      <span class="block font-bold">Open "Add" on mobile views by default</span>
      <span
        >For faster and easier entry input. Otherwise open Entries by
        default</span
      >
    </div>
    <mat-slide-toggle
      [checked]="defaultOpenAdderOnMobile"
      (change)="setDefaultViewForMobile($event)"
    ></mat-slide-toggle>
  </div>
  <div class="flex justify-between py-8">
    <div>
      <span class="block font-bold">Display currency</span>
      <span>Display setting for entry amounts</span>
    </div>
    <mat-form-field>
      <mat-select [(value)]="selected" (selectionChange)="setCurrency($event)">
        <mat-option [value]="null">None</mat-option>
        @for (currency of currencyService.currencies; track currency) {
        <mat-option [value]="currency.code">{{ currency.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
